export default __webpack_public_path__ + "static/media/certi3.f5617f03.JPG";